import { Component, OnInit, OnDestroy } from '@angular/core';
import { GlobalDataService } from '../global-data.service';
import {  LoginUser } from '../../_models';
import { Subscription } from 'rxjs';
import { AuthService } from '../../_services';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.css']
})
export class MenusComponent implements OnInit,OnDestroy {
  currentUser!: LoginUser;
  subscription!: Subscription;
  flgLock: boolean = false;
  constructor(
    private gd: GlobalDataService,
    private authService: AuthService
  ) {
  }
  ngOnInit() {
   
    this.currentUser = this.gd.getUserData();
    if(this.currentUser ==null){
      this.authService.authDetails("")
      .subscribe(data=> {
        this.gd.setUserData(this.currentUser);
        this.currentUser =data;
      });
    }
    this.subscription = this.gd.flgVOWDLock$.subscribe(
      flgVOWDLock => this.flgLock = flgVOWDLock
      );
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
